import React, { useEffect, useState } from "react";
import { LinkOutlined, CopyOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { STATUS } from "@/utils/enum";
import { getShareShipment } from "@/services/shipments_new";

const copyMapUrl = url => {
  window.open(url, "_blank");
};

const copyUrl = url => {
  navigator.clipboard.writeText(url);
  message.success("Copied link!");
};

const CopyButton = ({ shipmentId }) => {
  const [status, setStatus] = useState(STATUS.IDLE);
  const [shareUrl, setShareUrl] = useState("");

  useEffect(() => {
    if (!shipmentId) return;

    setStatus(STATUS.LOADING);
    getShareShipment(shipmentId)
      .then(data => {
        setShareUrl(data);
        setStatus(STATUS.SUCCESS);
      })
      .catch(() => {
        setStatus(STATUS.ERROR);
      });
  }, [shipmentId]);

  return (
    <div style={{ marginTop: 22 }}>
      <Button
        icon={<LinkOutlined />}
        onClick={() => copyMapUrl(shareUrl)}
        loading={status === STATUS.LOADING}
        disabled={!shareUrl}
      >
        View
      </Button>
      <Button
        icon={<CopyOutlined />}
        onClick={() => copyUrl(shareUrl)}
        style={{ marginLeft: 16 }}
        loading={status === STATUS.LOADING}
        disabled={!shareUrl}
      >
        Copy
      </Button>
    </div>
  );
};

export default CopyButton;
